"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteWatchlistService = void 0;
var watchlist_service_1 = require("./watchlist-service");
Object.defineProperty(exports, "AuthSuiteWatchlistService", { enumerable: true, get: function () { return watchlist_service_1.AuthSuiteWatchlistService; } });
